<script>
export default {
    data() {
        return {
            user_permissions: [],
            allow: false
        }
    },
    methods: {
        $can(current_user) {
            const current_permission = (typeof this.currentPermission == 'object' ? this.currentPermission : JSON.parse(this.currentPermission));
            const current_role = (typeof this.currentRole == 'object' ? this.currentRole : JSON.parse(this.currentRole));
            const permissions = current_permission.some(r => current_user.includes(r))

            if (current_role.includes('author')) {
                return true;
            } else {
                return permissions;
            }
        }
    },
    computed: {
        currentPermission() {
            return this.$store.getters['auth/permissions'] || []
        },
        currentRole() {
            return this.$store.getters['auth/roles'] || []
        }
    }
}
</script>
